import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoModule } from '@jsverse/transloco';

export interface NotificationDetailsData {
  details: string;
}

@Component({
  selector: 'app-notification-details-dialog',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, MatIconModule, TranslocoModule],
  templateUrl: './notification-details-dialog.component.html',
  styleUrls: ['./notification-details-dialog.component.scss'],
})
export class NotificationDetailsDialogComponent {
  readonly data: NotificationDetailsData = inject<NotificationDetailsData>(MAT_DIALOG_DATA);
  private readonly dialogRef = inject(MatDialogRef<NotificationDetailsDialogComponent>);

  close(): void {
    this.dialogRef.close();
  }
}
